module.exports = "<div class=\"user-permission-role-container col-md-10\">\n    <h3>\n        <a routerLink=\"/global-settings/permissions\">Roles</a>\n        /\n        <span *ngIf=\"roleName\">\n            {{ roleName }}\n        </span>\n    </h3>\n    <hr>\n    <user-permission-role id=\"user-permission-role\"></user-permission-role>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/global-settings/permission-settings/user-permission-role.component.html
// module id = ../../../../../src/app/global-settings/permission-settings/user-permission-role.component.html
// module chunks = 2